const hostPath = 'https://message-flow.test.keldysh.io';

export const environment = {
  hostPath: hostPath,
  apiPath: hostPath + '/api/landing-page-service',
  firebaseConfig: {
    apiKey: "AIzaSyB9xn558hUmxJ11ureJD30gJXc8wMpGOpw",
    authDomain: "keldysh-message-flow-test.firebaseapp.com",
    projectId: "keldysh-message-flow-test",
    storageBucket: "keldysh-message-flow-test.appspot.com",
    messagingSenderId: "832960039301",
    appId: "1:832960039301:web:d5756eaaebbd1b50e69cec",
    measurementId: "G-22X28T49SN"
  },
  production: false
};
